import dayjs, { type ConfigType } from "dayjs"
import "dayjs/locale/en-gb"
import "dayjs/locale/ru"
import localizedFormat from "dayjs/plugin/localizedFormat"
import relativeTime from "dayjs/plugin/relativeTime"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import { zodiacSigns } from "./constants"

// Prepare dayjs
dayjs.locale("en-gb")
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

export default dayjs

const FORMATTER = Intl.DateTimeFormat()

export function nextHour() {
  return dayjs().add(1, "hour").startOf("hour")
}

export function formatDate(date: Date) {
  return FORMATTER.format(date)
}

function buildAnniversary(base: dayjs.Dayjs, year: number) {
  const m = base.month() // 0..11
  const d = base.date()
  // 29 february is a special case
  if (d === 29 && m === 1) {
    const leap = dayjs(`${year}-02-29`)
    return leap.isValid() ? leap.startOf("day") : dayjs(`${year}-03-01`).startOf("day")
  }
  return base.year(year).startOf("day")
}

export function anniversaryDiff(date: ConfigType, minYearsPassed: number = 0) {
  const nextAnniv = nextAnniversary(date, minYearsPassed)
  return nextAnniv?.diff(dayjs().startOf("day"), "day")
}

export function isTodayDate(source: ConfigType) {
  return dayjs(source).date() === dayjs().date() && dayjs(source).month() === dayjs().month()
}

export function nextAnniversary(date: ConfigType, minYearsPassed: number = 0) {
  if (!date) return null

  const target = dayjs(date)
  if (!target.isValid()) return null

  const checkDate = dayjs().startOf("day")
  let candidateYear = Math.max(checkDate.year(), target.year() + minYearsPassed)
  let nextAnniv = buildAnniversary(target, candidateYear)
  if (nextAnniv.isBefore(checkDate)) {
    candidateYear += 1
    nextAnniv = buildAnniversary(target, candidateYear)
  }

  return nextAnniv
}

export function addWorkdays(startDate, workdays) {
  let date = dayjs(startDate)
  let addedDays = 0

  while (addedDays < workdays) {
    date = date.add(1, "day")
    const day = date.day()
    if (day !== 0 && day !== 6) addedDays++
  }

  return date
}

export function dateToSign(date: Date | number) {
  const sign = Number(new Intl.DateTimeFormat("fr-TN-u-ca-persian", { month: "numeric" }).format(date)) - 1
  return zodiacSigns[sign]
}
